// extracted by mini-css-extract-plugin
module.exports = {"goNextLink":"GoNextLink-styles-module--goNextLink--ncLaN","big":"GoNextLink-styles-module--big--ZwPkb","white":"GoNextLink-styles-module--white--2_Ntg"};